/* tslint:disable */
/* eslint-disable */
/**
 * Kontor API
 * OpenAPI specification for Kontor application framework
 *
 * The version of the OpenAPI document: 1.0.1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * All object attributes
 * @export
 * @interface TicketPurchaseRequestDataAttributes
 */
export interface TicketPurchaseRequestDataAttributes {
    /**
     * 
     * @type {string}
     * @memberof TicketPurchaseRequestDataAttributes
     */
    eventId: string;
    /**
     * Ticket orders per ticket category
     * @type {Array<object>}
     * @memberof TicketPurchaseRequestDataAttributes
     */
    tickets: Array<object>;
    /**
     * Name of customer
     * @type {string}
     * @memberof TicketPurchaseRequestDataAttributes
     */
    name: string;
    /**
     * Firstname of customer
     * @type {string}
     * @memberof TicketPurchaseRequestDataAttributes
     */
    firstName: string;
    /**
     * Postal address
     * @type {string}
     * @memberof TicketPurchaseRequestDataAttributes
     */
    company?: string;
    /**
     * Postal address
     * @type {string}
     * @memberof TicketPurchaseRequestDataAttributes
     */
    address: string;
    /**
     * Postal address
     * @type {string}
     * @memberof TicketPurchaseRequestDataAttributes
     */
    zip: string;
    /**
     * Postal address
     * @type {string}
     * @memberof TicketPurchaseRequestDataAttributes
     */
    city: string;
    /**
     * Postal address
     * @type {string}
     * @memberof TicketPurchaseRequestDataAttributes
     */
    phone: string;
    /**
     * Postal address
     * @type {string}
     * @memberof TicketPurchaseRequestDataAttributes
     */
    email: string;
    /**
     * Postal address
     * @type {string}
     * @memberof TicketPurchaseRequestDataAttributes
     */
    remarks?: string;
    /**
     * Confirmation for terms and conditions
     * @type {boolean}
     * @memberof TicketPurchaseRequestDataAttributes
     */
    termsAndConditionsRead: boolean;
    /**
     * Payment provider: Redirect URL for successful payments
     * @type {string}
     * @memberof TicketPurchaseRequestDataAttributes
     */
    successRedirectUrl: string;
    /**
     * Payment provider: Redirect URL for failed payments
     * @type {string}
     * @memberof TicketPurchaseRequestDataAttributes
     */
    failedRedirectUrl: string;
    /**
     * Payment provider: Redirect URL for cancelled payments
     * @type {string}
     * @memberof TicketPurchaseRequestDataAttributes
     */
    cancelRedirectUrl: string;
}

export function TicketPurchaseRequestDataAttributesFromJSON(json: any): TicketPurchaseRequestDataAttributes {
    return TicketPurchaseRequestDataAttributesFromJSONTyped(json, false);
}

export function TicketPurchaseRequestDataAttributesFromJSONTyped(json: any, ignoreDiscriminator: boolean): TicketPurchaseRequestDataAttributes {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'eventId': json['eventId'],
        'tickets': json['tickets'],
        'name': json['name'],
        'firstName': json['firstName'],
        'company': !exists(json, 'company') ? undefined : json['company'],
        'address': json['address'],
        'zip': json['zip'],
        'city': json['city'],
        'phone': json['phone'],
        'email': json['email'],
        'remarks': !exists(json, 'remarks') ? undefined : json['remarks'],
        'termsAndConditionsRead': json['termsAndConditionsRead'],
        'successRedirectUrl': json['successRedirectUrl'],
        'failedRedirectUrl': json['failedRedirectUrl'],
        'cancelRedirectUrl': json['cancelRedirectUrl'],
    };
}

export function TicketPurchaseRequestDataAttributesToJSON(value?: TicketPurchaseRequestDataAttributes | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'eventId': value.eventId,
        'tickets': value.tickets,
        'name': value.name,
        'firstName': value.firstName,
        'company': value.company,
        'address': value.address,
        'zip': value.zip,
        'city': value.city,
        'phone': value.phone,
        'email': value.email,
        'remarks': value.remarks,
        'termsAndConditionsRead': value.termsAndConditionsRead,
        'successRedirectUrl': value.successRedirectUrl,
        'failedRedirectUrl': value.failedRedirectUrl,
        'cancelRedirectUrl': value.cancelRedirectUrl,
    };
}

